<template>
    <div class="imagWrap">
        <div v-if="list.length">
            <div v-for="item in list" :key="item.id" class="comparisonContent">
                <div class="conTitle">
                    {{ item.title }}
                </div>
                <div class="contentFlex">
                    <div v-for="item2 in item.product_list" :key="item2.id" class="conItem">
                        <div class="imgWrap">
                            <div class="imgText">{{ item2.desc }}</div>
                            <img :src="item2.cover" alt="" />
                        </div>
                        <div class="footText">{{ item2.title }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="comparisonContent">
                <div class="conTitle">
                    {{ dataInfo.title }}
                </div>
                <div class="contentFlex">
                    <div v-for="item in dataInfo.content" :key="item.id" class="conItem">
                        <div class="imgWrap">
                            <div class="imgText">{{ item.desc }}</div>
                            <img :src="item.cover" alt="" />
                        </div>
                        <div class="footText">{{ item.title }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        list: {
            type: Array,
            default: (() => [])
        },
        dataInfo: {
            type: Object,
            default: () => {
                return {
                    content: [],
                }
            }
        },
    },
    data() {
        return {

        }
    },
    created() {

    },
    methods: {

    },
}
</script>

<style lang="scss" scoped>
.imagWrap {
    width: 1200px;
    margin: auto;
    margin-top: 0;
    margin-bottom: 116px;
}

.comparisonContent {
    margin-top: 100px;

    .conTitle {
        font-size: 40px;
        color: #000000;
        line-height: 40px;
    }

    .contentFlex {
        margin-top: 48px;
        display: flex;
        flex-wrap: wrap;
        gap: 30px;
        margin-bottom: 100px;

        .conItem {
            width: 585px;

            .imgWrap {
                width: 100%;
                position: relative;

                .imgText {
                    width: 100%;
                    position: absolute;
                    left: 0;
                    top: 47px;
                    font-size: 18px;
                    color: #231815;
                    text-align: center;
                }

                img {
                    width: 100%;
                    height: 700px;
                    object-fit: cover;
                    display: block;
                }
            }

            .footText {
                margin-top: 40px;
                font-size: 21px;
                color: #000000;
            }
        }
    }
}

@media screen and (max-width:1200px) {
    .imagWrap {
        width: 100%;
        margin: auto;
    }

    .comparisonContent {
        margin-top: 50px;

        .conTitle {
            font-size: 18px;
            color: #000000;
            line-height: 30px;
        }

        .contentFlex {
            margin-top: 20px;
            display: flex;
            flex-wrap: wrap;
            gap: 20px;
            margin-bottom: 50px;

            .conItem {
                width: calc((100% - 20px) / 2);

                .imgWrap {
                    width: 100%;
                    position: relative;

                    .imgText {
                        width: 100%;
                        position: absolute;
                        left: 0;
                        top: 15px;
                        font-size: 12px;
                        color: #231815;
                        text-align: center;
                    }

                    img {
                        width: 100%;
                        height: auto;
                        aspect-ratio: 585 / 700;
                        object-fit: cover;
                        display: block;
                    }
                }

                .footText {
                    margin-top: 20px;
                    font-size: 14px;
                    color: #000000;
                    text-align: center;
                }
            }
        }
    }
}
</style>